"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileAssociation = exports.streamMediaParamsDef = exports.fileBusinessId = void 0;
const joi_1 = __importDefault(require("joi"));
const types_1 = require("./types");
const schemaValidator_1 = require("../../util/schemaValidator");
const general_1 = require("../general");
const BusinessIds_1 = require("./BusinessIds");
const time_1 = require("../../util/time");
exports.fileBusinessId = Object.assign(Object.assign(Object.assign({}, general_1.daoObjSchemaDef), BusinessIds_1.componentBusinessId), { uniqueFileIdentifier: joi_1.default.string(), learnerNumber: joi_1.default.number() });
exports.streamMediaParamsDef = {
    businessUnitId: joi_1.default.string(),
    id: joi_1.default.string(),
};
exports.fileAssociation = Object.assign(Object.assign({}, general_1.daoObjSchemaDef), { virusScanState: joi_1.default.string()
        .valid(types_1.VirusScanState.NEGATIVE, types_1.VirusScanState.POSITIVE, types_1.VirusScanState.UNSCANNED)
        .allow(null)
        .required(), originalFileName: joi_1.default.string(), fileBusinessId: (0, schemaValidator_1.objectSchema)(exports.fileBusinessId).required(), s3Key: joi_1.default.string().required(), uploader: joi_1.default.object({
        email: joi_1.default.string().required(),
        name: joi_1.default.string().required(),
    }), totalSize: joi_1.default.number(), uploaded: joi_1.default.string().default(() => (0, time_1.buildNow)()().toISOString()), submittedAt: joi_1.default.string().optional(), deletedAt: joi_1.default.string().optional() });
